import { MutationTree } from "vuex";
import { Casier } from "../../models/Casier";
import { Location } from "../../models/Location";
import { Niveau } from "../../models/Niveau";
import { Pavillon } from "../../models/Pavillon";
import { Periode } from "../../models/Periode";
import { Pilotage } from "../../models/Pilotage";
import { TypeClientele } from "../../models/TypeClientele";
import { VariableEnvironnementDefinition } from "../../models/VariableEnvironnementDefinition";
import { VariableEnvironnementValue } from "../../models/VariableEnvironnementValue";
import { ICDSState, stateDeBase } from "../models";

interface IMutations {
  recupererLocationsSucces: (state: ICDSState, payload: Location[]) => void;
  recupererLocationsEchec: (state: ICDSState) => void;

  recupererTypesClienteleSucces: (
    state: ICDSState,
    payload: TypeClientele[]
  ) => void;
  recupererTypesClienteleEchec: (state: ICDSState) => void;

  recupererPeriodesSucces: (state: ICDSState, payload: Periode[]) => void;
  recupererPeriodesEchec: (state: ICDSState) => void;

  recupererPavillonsAvecCasiersDisposSucces: (
    state: ICDSState,
    payload: Pavillon[]
  ) => void;
  recupererPavillonsAvecCasiersDisposEchec: (state: ICDSState) => void;

  recupererNiveauxAvecCasiersDisposSucces: (
    state: ICDSState,
    payload: Niveau[]
  ) => void;
  recupererNiveauxAvecCasiersDisposEchec: (state: ICDSState) => void;

  recupererCasiersDisposEtBonEtatParNiveauSucces: (
    state: ICDSState,
    payload: Casier[]
  ) => void;
  recupererCasiersDisposEtBonEtatParNiveauEchec: (state: ICDSState) => void;

  recupererDefinitionsVariablesEnvSucces: (
    state: ICDSState,
    payload: VariableEnvironnementDefinition[]
  ) => void;
  recupererDefinitionsVariablesEnvEchec: (state: ICDSState) => void;

  recupererValeursVariablesEnvSucces: (
    state: ICDSState,
    payload: VariableEnvironnementValue[]
  ) => void;
  recupererValeursVariablesEnvEchec: (state: ICDSState) => void;

  recupererParametresPilotageSucces: (
    state: ICDSState,
    payload: Pilotage[]
  ) => void;
  recupererParametresPilotageEchec: (state: ICDSState) => void;

  effacerStateCDS: (state: ICDSState) => void;
}

export const mutations: IMutations & MutationTree<ICDSState> = {
  recupererLocationsSucces: (state: ICDSState, payload: Location[]) => {
    state.locations = payload;
  },
  recupererLocationsEchec: (state: ICDSState) => {
    state.locations = [];
  },

  recupererTypesClienteleSucces: (
    state: ICDSState,
    payload: TypeClientele[]
  ) => {
    state.typesClientele = payload;
  },
  recupererTypesClienteleEchec: (state: ICDSState) => {
    state.typesClientele = [];
  },

  recupererPeriodesSucces: (state: ICDSState, payload: Periode[]) => {
    state.periodes = payload;
  },
  recupererPeriodesEchec: (state: ICDSState) => {
    state.periodes = [];
  },

  recupererPavillonsAvecCasiersDisposSucces: (
    state: ICDSState,
    payload: Pavillon[]
  ) => {
    state.pavillons = payload;
  },
  recupererPavillonsAvecCasiersDisposEchec: (state: ICDSState) => {
    state.pavillons = [];
  },

  recupererNiveauxAvecCasiersDisposSucces: (
    state: ICDSState,
    payload: Niveau[]
  ) => {
    state.niveaux = payload;
  },
  recupererNiveauxAvecCasiersDisposEchec: (state: ICDSState) => {
    state.niveaux = [];
  },

  recupererCasiersDisposEtBonEtatParNiveauSucces: (
    state: ICDSState,
    payload: Casier[]
  ) => {
    state.casiers = payload;
  },
  recupererCasiersDisposEtBonEtatParNiveauEchec: (state: ICDSState) => {
    state.casiers = [];
  },

  recupererValeursVariablesEnvSucces: (
    state: ICDSState,
    payload: VariableEnvironnementValue[]
  ) => {
    state.valeursVariablesEnv = payload;
  },
  recupererValeursVariablesEnvEchec: (state: ICDSState) => {
    state.valeursVariablesEnv = [];
  },

  recupererDefinitionsVariablesEnvSucces: (
    state: ICDSState,
    payload: VariableEnvironnementDefinition[]
  ) => {
    state.definitionsVariablesEnv = payload;
  },
  recupererDefinitionsVariablesEnvEchec: (state: ICDSState) => {
    state.definitionsVariablesEnv = [];
  },

  recupererParametresPilotageSucces: (
    state: ICDSState,
    payload: Pilotage[]
  ) => {
    state.parametresPilotage = payload;
  },
  recupererParametresPilotageEchec: (state: ICDSState) => {
    state.parametresPilotage = [];
  },

  effacerStateCDS: (state: ICDSState) => {
    Object.assign(state, stateDeBase());
  },
};
